module.exports = __webpack_public_path__ + "static/postcard-f8db465e67983059525f8c5e0b1e8820.jpg";